<cloze-test [mobileMode]="mobileMode()" [lang]="lang()" [clozeTestModel]="clozeTestModel()"
    [clozeTestStyleModel]="clozeTestStyleModel()" [showResult]="true" [showEndTestButton]="false"
    [showExerciseExample]="false" (startTest)=onStartTest($event)
    (testSaved)=onTestHasBeenSaved($event) (clozeTest)=onClozeTestCompleted() (testResult)=onTestResult($event)
    [introductionType]="introductionType()"
    [headerLogo]="'assets/daad-logo.svg'" [headerLogoTitle]="'Study Guide'"
    [headerLogoTitleImage]="'assets/study-guide-logo.svg'" [headerTitle]="'Spracheinstufung'">
</cloze-test>